module.exports = __webpack_public_path__ + "static/media/service-icon.f1b6b5d1.svg";